import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { BaseUrl } from '../API/Url';
import { useCookies } from 'react-cookie';
import Loading from '../components/Loading/Loading';

export default function AdminProtector(props) {

    const [loading, setLoading] = useState(true);
    const [Cookies] = useCookies(['token'])
    const [CheckUser, setCheckUser] = useState(null)


    const CheckForUser = async () => {

        if (!Cookies.token) {
            setCheckUser(false)
            return;
        }

        try {
            const res = await axios.post(`${BaseUrl}/auth/CheckAdmin`, {}, {
                headers: {
                    token: Cookies.token && Cookies.token
                }
            });
            setCheckUser(res.data.status);

        } catch (error) {
            setCheckUser(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {


        if (Cookies.token) {
            CheckForUser();
        }
    }, [Cookies.token]);

    if (loading) {
        return <Loading />;
    }



    if (CheckUser) {
        return props.children;
    } else {
        return <Navigate to={"/Login"} />;
    }
}
